import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export interface ErrorIndicator {
  id: string;
  position: 'top' | 'bottom';
  timestamp: number;
}

export const useErrorIndicatorStore = defineStore('errorIndicator', () => {
  const errorIndicators = ref<ErrorIndicator[]>([]);

  const activeIndicators = computed(() => {
    return errorIndicators.value.filter((indicator) => {
      // Remove indicators older than 5 seconds
      return Date.now() - indicator.timestamp < 10000;
    });
  });

  const addErrorIndicator = (position: 'top' | 'bottom') => {
    const id = `error-${position}-${Date.now()}`;

    const newIndicator: ErrorIndicator = {
      id,
      position,
      timestamp: Date.now(),
    };

    // Remove any existing indicators for the same position
    errorIndicators.value = errorIndicators.value.filter(
      (existing) => existing.position !== position,
    );

    errorIndicators.value.push(newIndicator);
  };

  const removeErrorIndicator = (id: string) => {
    errorIndicators.value = errorIndicators.value.filter(
      (indicator) => indicator.id !== id,
    );
  };

  const clearIndicatorsByPosition = (position: 'top' | 'bottom') => {
    errorIndicators.value = errorIndicators.value.filter(
      (indicator) => indicator.position !== position,
    );
  };

  const clearAllIndicators = () => {
    errorIndicators.value = [];
  };

  return {
    errorIndicators,
    activeIndicators,
    addErrorIndicator,
    removeErrorIndicator,
    clearIndicatorsByPosition,
    clearAllIndicators,
  };
});
